<template>
    <div id="app" class="corpo">
      <dap-header/>
      <div class="container-fluid">
        <div class="pagina">
          <transition name="pagina">
            <router-view></router-view>
          </transition>
        </div>
      </div>
      <dap-footer/>
    </div>
</template>
<script>
import Header from "@/components/shared/template/Header.vue";
import Footer from "@/components/shared/template/Footer.vue";

export default {
  name: "app",
  components: {
    "dap-header": Header,
    "dap-footer": Footer
  }
};
</script>

<style>
body{
  font-family: 'Alef', sans-serif;
}
.pagina {
  padding-bottom: 80px!important;
}
div.mainContainer {
  width: 800px!important;
}
.panel-default > .panel-heading {
  background-color: #fff!important;
  border:none;
}
.panel-heading h3 {
  text-align: center!important;
  color: #5a5a5a!important;
  font-size: 24px!important;
  font-weight: bolder!important;
  color: #2980b9!important;
}
textarea.form-control {
  border: 1px solid #e8e8e8!important;
  border-radius: 5px!important;
  background-color: #fff!important;
  padding: 0 15px!important;
  width: 100%!important;
  height: 150px!important;
  line-height: 28px!important;
  font-size: 20px!important;
  font-family: "Open Sans Hebrew", sans-serif!important;
  resize: none!important;
}
.addSomePadding {
  padding: 20px!important;
}
</style>



// WEBPACK FOOTER //
// App.vue?85d2e606